import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Button, InputLabel, TextField, Typography } from "@mui/material";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { ClassicEditor } from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';
import '../styles/CKEditor.css'
import { editorConfig } from '../functions/utilities/EditorConfig';

const EditBlogDetails = () => {
    const [blog, setBlog] = useState({});
    const id = useParams().id;
    const navigate = useNavigate();
    const [inputs, setInputs] = useState({});

    // get blog details
    const getBlogDetail = useCallback(async () => {
        try {
            const { data } = await axios.get(`/api/v1/blog/get-blog/${id}`);
            if (data?.success) {
                setBlog(data?.blog);
                setInputs({
                    title: data?.blog.title,
                    description: data?.blog.description,
                    content: data?.blog.content,
                    image: data?.blog.image,
                    category: data?.blog.category || "",
                    profImg: blog?.user?.profImg,

                });
            }
        } catch (error) {
            console.log(error);
        }
    }, [id]);

    useEffect(() => {
        getBlogDetail();
    }, [id, getBlogDetail]);

    // input change
    const handleChange = (e) => {
        setInputs((prevState) => ({
            ...prevState,
            [e.target.name]: e.target.value,
        }));
    };
    const delay = async (ms) => {
        return new Promise((resolve) =>
            setTimeout(resolve, ms));
    };

    //form
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const { data } = await axios.put(`/api/v1/blog/update-blog/${id}`, {
                title: inputs.title,
                description: inputs.description,
                content: inputs.content,
                image: inputs.image,
                category: inputs.category,
            });
            if (data?.success) {
                await delay(500);
                toast.success("Blog Updated");
                await delay(500);
                navigate("/blogs");
            }
        } catch (error) {
            console.log(error);
        }
    };
    console.log(blog);

    return (
        <v>
            <form onSubmit={handleSubmit}>
                <Box
                    width={"80%"}
                    padding={3}
                    margin="auto"
                    boxShadow={"10px 10px 20px #ccc"}
                    display="flex"
                    flexDirection={"column"}
                    marginTop="30px"
                >
                    <Typography
                        variant="h2"
                        textAlign={"center"}
                        fontWeight="bold"
                        padding={3}
                    >
                        Update Blog
                    </Typography>
                    <InputLabel
                        sx={{ mb: 1, mt: 2, fontSize: "24px", fontWeight: "bold" }}
                    >
                        Title
                    </InputLabel>
                    <TextField
                        name="title"
                        value={inputs.title}
                        onChange={handleChange}
                        margin="normal"
                        variant="outlined"
                        required
                    />
                    <InputLabel
                        sx={{ mb: 1, mt: 2, fontSize: "24px", fontWeight: "bold" }}
                    >
                        Description
                    </InputLabel>
                    <TextField
                        name="description"
                        value={inputs.description}
                        onChange={handleChange}
                        margin="normal"
                        variant="outlined"
                        required
                    />

                    <InputLabel
                        sx={{ mb: 1, mt: 2, fontSize: "24px", fontWeight: "bold" }}
                    >
                        Content
                    </InputLabel>
                    <CKEditor
                        editor={ClassicEditor}
                        config={editorConfig}
                        data={inputs.content}
                        onReady={editor => {
                            console.log('Editor is ready to use!', editor);
                        }}
                        onChange={(event, editor) => {
                            const data = editor.getData();
                            setInputs((prevState) => {
                                return {
                                    ...prevState, content: data
                                }
                            });
                        }}
                        onBlur={(event, editor) => {
                            console.log('Blur.', editor);
                        }}
                        onFocus={(event, editor) => {
                            console.log('Focus.', editor);
                        }}
                        required
                    />
                    <InputLabel
                        sx={{ mb: 1, mt: 2, fontSize: "24px", fontWeight: "bold" }}
                    >
                        Image URL
                    </InputLabel>
                    <TextField
                        name="image"
                        value={inputs.image}
                        onChange={handleChange}
                        margin="normal"
                        variant="outlined"
                        required
                    />
                    <InputLabel
                        sx={{ mb: 1, mt: 2, fontSize: "24px", fontWeight: "bold" }}
                    >
                        Category
                    </InputLabel>
                    <TextField
                        select
                        name="category"
                        value={inputs.category}
                        onChange={handleChange}
                        SelectProps={{
                            native: true,
                        }}
                        variant="outlined"
                        required
                    >
                        <option value="">Select Category</option>
                        <option value="Nutrition">Nutrition</option>
                        <option value="Dogs">Dogs</option>
                        <option value="Cats">Cats</option>
                        <option value="Health & Wellness">Health & Wellness</option>
                        <option value="Training & Behavior">Training & Behavior</option>
                        <option value="Pet Adoption & Rescue">Pet Adoption & Rescue</option>
                    </TextField>
                    <Typography textAlign={"center"}>
                        <Button type="submit" color="primary" variant="contained" >
                            UPDATE
                        </Button>
                    </Typography>

                </Box>
            </form>
        </v>
    );
};

export default EditBlogDetails;